<template>
  <div class="content-following-view">
    <h1 class="page-header">
      Followed Content Partners
    </h1>
    <div v-if="followedContentPartners.length === 0">
      <p>
        It looks like you're not following any of our content partners, yet. <router-link :to="{ name: 'content-partners#index' }">
          Check out our list of partners to follow your favorites!
        </router-link>
      </p>
    </div>
    <div
      v-for="partner in followedContentPartners"
      v-else
      :key="partner.id"
      class="partner-carousel"
    >
      <div class="carousel-header">
        <p class="partner-name">
          {{ partner.name }}
        </p>
        <router-link
          class="partner-link"
          :to="partnerRoute(partner)"
        >
          View All
        </router-link>
      </div>
      <carousel
        :item-width="263"
        :tile-count="partnerAssets(partner).length"
        tile-type="block"
      >
        <asset-block-tile
          v-for="asset in partnerAssets(partner)"
          :key="`${asset.assetType}-${asset.id}`"
          :asset="asset"
          @tile-clicked="handleTileClick(asset)"
        />
      </carousel>
    </div>
  </div>
</template>

<script>
import Carousel from '@/components/carousels/carousel';
import AssetBlockTile from '@/components/singletons/asset-block-tile';

export default {
  components: { AssetBlockTile, Carousel },
  data() {
    return {
      assets: {},
    };
  },
  computed: {
    followedContentPartners() {
      return this.$store.getters['user/contentFollows'].map(follow => this.$store.getters['contentPartners/get'][follow.contentPartnerId]);
    },
  },
  mounted() {
    const ids = this.followedContentPartners.map(partner => partner.id);
    if (ids?.length > 0) {
      this.$store.dispatch('contentPartners/fetchContentPartnerAssets', { ids }).then(data => {
        this.assets = data;
      });
    }
  },
  methods: {
    handleTileClick(asset) {
      this.$router.push({
        name: 'library#show',
        params: {
          assetId: asset.id,
          assetType: asset.assetType,
        },
      });
    },
    partnerAssets(partner) {
      if (!this.assets[partner.id]) {
        return [];
      }
      let partnerAssets = this.assets[partner.id];
      let attachments = partnerAssets.attachments.map(attachmentId => this.$store.getters['attachments/get'][attachmentId]).filter(a => a);
      let decks = partnerAssets.decks.map(deckId => this.$store.getters['decks/get'][deckId]).filter(d => d);
      let learningModules = partnerAssets.learningModules.map(lm => this.$store.getters['learningModule/get'][lm.id]).filter(lm => lm);
      let topics = partnerAssets.topics.map(topic => this.$store.getters['topics/topics'][topic.id]).filter(t => t);
      let assets = [...attachments, ...decks, ...learningModules, ...topics];

      return assets;
    },
    partnerRoute(partner) {
      return {
        name: 'content-partners#show',
        params: {
          contentPartnerId: partner.id,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.content-following-view {
  margin: 0 auto;
  max-width: rem-calc(768);

  .page-header {
    @include charter-font;
  }

  .carousel-header {
    color: #767676;
    display: flex;
    font-size: rem-calc(14);
    font-weight: $semi-bold;
    justify-content: space-between;
    text-transform: uppercase;

    .partner-name,
    .partner-link {
      margin: 0;
    }

    .partner-link {
      color: inherit;
      text-decoration: none;
    }
  }
}
</style>
